'use client';

import { useAppDispatch } from '@/hooks/redux';
import {
  APP_EVENTS,
  COMMON_EVENTS,
  logHubxEvent,
} from '@/app/providers/analytics';
import usePaddlePricing from '@/features/subscription/hooks/usePaddlePricing';
import { setTypeForUserAccessLevel } from '@/store/slices/userAccessSlice';
import { setUploadIntent } from '@/features/tool/slices/uploadSlice';
import { PDF_ONLY_FILE_TYPES } from '@/features/tool/utils/uploadConstraints';
import { getPrimaryPrice } from '@/helpers/pricing-helper';
import Button from '@/components/NextUI/Button';

const HeroActions = ({
  primaryLabel,
  secondaryLabel,
}: {
  primaryLabel: string;
  secondaryLabel: string;
}) => {
  const dispatch = useAppDispatch();
  const { yearlyPrices, monthlyPrices, weeklyPrices } = usePaddlePricing();

  const showSideFunction = () => {
    dispatch(
      setUploadIntent({
        targetPath: '/app/edit-pdf?tool=edit-pdf',
        fileTypes: PDF_ONLY_FILE_TYPES,
        multiple: false,
      })
    );
    logHubxEvent({ eventName: APP_EVENTS.BTN_BANNER_FREE_TRIAL });
    dispatch(setTypeForUserAccessLevel('banner_start_trial'));
    const primaryPrice = getPrimaryPrice({
      yearlyPrices,
      monthlyPrices,
      weeklyPrices,
    });

    logHubxEvent({
      eventName: COMMON_EVENTS.PURCHASE_BUTTON_CLICK,
      event_params: {
        paywallType: 'banner_start_trial',
        currency: primaryPrice?.unit_price?.currency_code,
        amount: (primaryPrice?.unit_price?.amount ?? 0) / 100,
        product_id: primaryPrice?.product_id!,
      },
    });
  };

  return (
    <div className="mt-8 md:mt-10 gap-4 md:gap-5 flex flex-wrap">
      <Button
        className="!min-w-[150px] md:!min-w-[180px]"
        onClick={() => showSideFunction()}
      >
        {primaryLabel}
      </Button>
      <Button
        className="!min-w-[150px] md:!min-w-[180px]"
        variant="outline"
        href="/tools"
        onClick={() =>
          logHubxEvent({ eventName: APP_EVENTS.BTN_BANNER_ALL_TOOLS })
        }
      >
        {secondaryLabel}
      </Button>
    </div>
  );
};

export default HeroActions;
